module.exports = __webpack_public_path__ + "img/7zip.fdf9a176.svg";